<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      round
      highlight-hover-row
      :height="tableHeight"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumn"
      :loading="loading"
      keep-source
      :editConfig="{
        trigger: 'click',
        mode: 'row',
        enabled: true,
        showStatus: true,
      }"
    >
      >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame group-title">
            {{ $l("form_group_fabric_color") || "面料颜色明细" }}
          </div>
        </slot>
      </template>
      <template v-slot:opt="{ row }">
        <div v-if="!disabled">
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
          >
            <i class="el-icon-edit tool-btn" @click="editRowEvent(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
export default {
  props: {
    mainType: {
      type: String,
    },
    disabled: {
      default: true,
      type: Boolean,
    },
    params: {
      default: null,
      type: Object,
    },
  },
  components: {},
  data() {
    return {
      loading: false,
      tableHeight: 375,
      tableData: [],
      tableToolbar: {
        slots: {
          buttons: "toolbar_form",
        },
      },
    };
  },
  computed: {
    tableColumn() {
      return [
        {
          field: "col-opt",
          title: this.$l("INDEX.table_label_operation") || "操作",
          align: "center",
          width: 150,
          fixed: "right",
          slots: {
            default: "opt",
          },
        },
        // { width: 50, fixed: 'left', type: this.single ? 'radio' : 'checkbox' },
        {
          field: "seq",
          width: 60,
          align: "center",
          fixed: "left",
          type: "seq",
        },
        {
          field: "fabricColorNo",
          width: 200,
          title: this.$l("form_label_fabric_color_no") || "面料颜色编号",
        },
        {
          field: "fabricColorTitle",
          minWidth: 300,
          title: this.$l("form_label_fabric_color_name") || "面料颜色",
        },
        {
          field: "wid",
          minWidth: 150,
          title: this.$l("form_label_actualFabricWid") || "实际门幅",
          showOverflow: true,
          editRender: {
            enabled: !this.disabled,
            name: "ElInputNumber",
            props: {
              controlsPosition: "right",
              style: "width:100%",
              min: 0,
              step: 0.01,
              precision: 2,
              size: "small",
            },
            immediate: true,
          },
        },
        {
          field: "widUnit",
          minWidth: 150,
          title: this.$l("form_label_actualWidUnit") || "门幅单位",
          showOverflow: true,
          editRender: {
            enabled: !this.disabled,
            name: "dict-select",
            props: {
              url: "/digitalCenter/common/dict/biz",
              body: { dictType: "widUnit" },
              placeholder: this.$l("INDEX.tips_select_data") || "请选择...",
              size: "mini",
              filterable: true,
              clearable: true,
              style: "width:100%",
            },
            immediate: true,
          },
        },
        {
          field: "fabricWeight",
          minWidth: 150,
          title: this.$l("form_label_actualFabricWeight") || "实际克重",
          showOverflow: true,
          editRender: {
            enabled: !this.disabled,
            name: "ElInputNumber",
            props: {
              controlsPosition: "right",
              style: "width:100%",
              min: 0,
              step: 0.01,
              precision: 2,
              size: "small",
            },
            immediate: true,
          },
        },
        {
          field: "fabricWeightUnit",
          minWidth: 150,
          title: this.$l("form_label_actualFabricWeightUnit") || "克重单位",
          showOverflow: true,
          editRender: {
            enabled: !this.disabled,
            name: "dict-select",
            props: {
              url: "/digitalCenter/common/dict/biz",
              body: { dictType: "fabricWeightUnit" },
              placeholder: this.$l("INDEX.tips_select_data") || "请选择...",
              size: "mini",
              filterable: true,
              clearable: true,
              style: "width:100%",
            },
            immediate: true,
          },
        },
        {
          field: "requestQuantity",
          minWidth: 150,
          title: this.$l("form_label_request_quantity") || "需求数量",
        },
        {
          field: "inStockQuantity",
          minWidth: 150,
          title: this.$l("form_label_actual_stock_quantity") || "入库数量",
          showOverflow: true,
          editRender: {
            enabled: !this.disabled,
            name: "ElInputNumber",
            props: {
              controlsPosition: "right",
              style: "width:100%",
              min: 0,
              step: 0.01,
              precision: 2,
              size: "small",
            },
            immediate: true,
          },
        },
      ];
    },
  },
  methods: {
    load(params) {
      this.loading = true;
      this.$api
        .fabricStockInColorListApi({
          ...(params || this.params),
        })
        .then((res) => {
          this.loading = false;
          this.tableData = res.body.data;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    editRowEvent(row) {
      const $grid = this.$refs.table;
      $grid.setActiveRow(row);
    },
    getUpdateTableData() {
      const updateRecords = this.$refs.table.getUpdateRecords();
      if (!updateRecords || updateRecords.length < 1) return [];
      return updateRecords;
    },
  },
};
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}
.side-frame-success {
  padding: 1px 10px;
  border-left: 3px solid $color-success;
  margin: 15px 0;
}
.group-title {
  font-size: 14px;
  color: #606266;
}
</style>
